import React, { memo, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

import { OEContext } from '@aytm/app/stats/page/comments/index'

import {
  pathQuestionIdToOld,
  questionByPath,
  questionOldIdToId,
  responseTagsByPath
} from '@aytm/app/stats/page/comments/lib/utils'
import { DEFAULT_SELECTED_QUESTION } from '@aytm/app/stats/page/comments/lib/constants'

import ImageResponseItem from '@aytm/app/stats/page/comments/image-responses/ImageResponseItem'

const Response = memo(
  ({ survey, reportVirtual, reportSchema, response, onUpdateParams, isShowPopup, setIsShowPopup }) => {
    const { searchState, commentStatusesState } = useContext(OEContext)

    const { request, isResponseOrder } = searchState
    const { selectedQuestion } = request
    const { uid: responseId } = response.response
    const rejectStatus = commentStatusesState.reject[responseId]
    const hasQuestionOrder = Boolean(response.session && response.session.order)
    const isRejected = rejectStatus && 'true' == rejectStatus

    const questionsKeys = useMemo(() => {
      const answers =
        hasQuestionOrder && isResponseOrder
          ? response.session.order.filter(keyName => {
              const newKeyName = questionOldIdToId(keyName, survey)
              return (reportSchema.length
                ? reportSchema.some(schemaKey => newKeyName == questionOldIdToId(schemaKey, survey))
                : true) && selectedQuestion !== DEFAULT_SELECTED_QUESTION
                ? 0 == selectedQuestion.indexOf(newKeyName)
                : true
            })
          : (reportSchema.length ? reportSchema : Object.keys(response.answer)).reduce((acc, cur) => {
              const newKeyName = questionOldIdToId(cur, survey)
              if (
                selectedQuestion == DEFAULT_SELECTED_QUESTION ||
                (selectedQuestion !== DEFAULT_SELECTED_QUESTION && 0 == selectedQuestion.indexOf(newKeyName))
              )
                response.answer[cur] && acc.push(cur)
              return acc
            }, [])
      return answers.map(keyName => {
        return {
          keyName,
          path: questionOldIdToId(keyName, survey),
          question: questionByPath(keyName, survey, reportVirtual)
        }
      })
    }, [response, isResponseOrder, hasQuestionOrder, reportSchema, reportVirtual, selectedQuestion, survey])

    return questionsKeys.length ? (
      <>
        {questionsKeys.map(({ keyName, path, question }) =>
          question ? (
            <ImageResponseItem
              key={`Response${responseId}_Question${keyName}`}
              path={path}
              question={question}
              survey={survey}
              isRejected={isRejected}
              response={response}
              isShowPopup={isShowPopup}
              setIsShowPopup={setIsShowPopup}
              answer={response.answer[keyName]}
              tags={responseTagsByPath(response, pathQuestionIdToOld(path))}
              responseId={responseId}
              dataId={`Response${responseId}_Question${keyName}`}
              onUpdateParams={onUpdateParams}
            />
          ) : null
        )}
      </>
    ) : null
  }
)

Response.propTypes = {
  dataId: PropTypes.string,
  reportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  survey: PropTypes.object,
  reportVirtual: PropTypes.object,
  reportSchema: PropTypes.array,
  response: PropTypes.object,
  showTraitsRef: PropTypes.object,
  responseOrderRef: PropTypes.object,
  isShowHiddenFilters: PropTypes.bool,
  isShowPopup: PropTypes.string,
  setIsShowPopup: PropTypes.func,
  onUpdateParams: PropTypes.func,
  onCloseNotification: PropTypes.func
}

Response.displayName = 'Response'

export default Response
